import $ from 'jquery';
import React from "react";
import ProjectScope from "./projectScope";
import QuantityTextField from "./../quantityTextField";
import ActionTypes from "./../../actionTypes";
import * as Misc from "./../../misc";
import * as Analytics from './../../analytics';

export default class ProjectScopeMaterialContent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      material: ProjectScope.quote().material,
      activeSelection: ""
    };
  }

  componentDidMount() {
    $(document).on(ActionTypes.QUOTE_DATA_CHANGED, this.handleQuoteDataChanged);
  };

  componentWillUnmount() {
    $(document).off(ActionTypes.QUOTE_DATA_CHANGED, this.handleQuoteDataChanged);
  }

  handleQuoteDataChanged = () => {
    this.setState({material: ProjectScope.quote().material});
  };

  handleSelectionChange = (selection) => {
    Analytics.sendClickEvent('material-shape-selected: ' + selection);
    let material = 0;
    switch (selection) {
      case "straight":
        material = 30;
        break;
      case "cornered":
        material = 45;
        break;
      case "withwalls":
        material = 60;
        break;
    }
    this.setState({activeSelection: selection, material}, () => {
      window.setTimeout(() => this.handleMaterialChange(material), 250);
    });
  };

  handleMaterialChange = (material) => {
    Analytics.sendDataEnteredEvent("project-scope-material");
    ProjectScope.updateMaterialQuantity(material);
  };

  handleMaterialChangeBlur = (material) => {
    var mat = parseInt(material);

    if(isNaN(mat) || mat <= 0) {
      mat = 1;
    }
    this.handleMaterialChange(mat);
  }

  showSquareFootCalc = (e) => {
    Analytics.sendClickEvent("project-scope-show-square-foot-calc")
    Misc.ignoreDefault(e);
    this.props.showSquareFootCalc('shapes');
  };

  render() {
    return (
      this.props.mainview ? (
        <div className="project-scope-main-body dragend-page" data-step="0">
          <header className="project-scope-main-header">
            <div className="project-scope-main-header-cell">
              <div className="project-scope-main-header-logo">
                <div className={"project-scope-main-header-logo-image project-scope-fading project-scope-main-header-logo-image--"
                +this.props.groupName.trim().toLowerCase().replace(" ","-")}/>
                <div className="project-scope-main-header-logo-border"/>
                <div className="project-scope-main-header-logo-circle">
                  <div className="project-scope-main-header-logo-circle-inner rotating"/>
                </div>
              </div>
            </div>
            <div className="project-scope-main-header-cell">
              <div className="project-scope-fading">
                {/*<HelpIcon title={this.props.groupName} todoType={this.props.groupName}/>*/}
                <div className="project-scope-main-header-title">STEP 1</div>
                <div className="project-scope-main-header-content-input">
                  <p className="project-scope-main-header-text">Enter the SQFT of materials</p>
                  <QuantityTextField value={this.state.material} className="project-scope-textbox"
                                     onChange={this.handleMaterialChange}
                                     onBlur={this.handleMaterialChangeBlur}
                                     title="Material quantity"/>
                </div>
              </div>
            </div>
          </header>
          <div className="project-scope-main-content project-scope-main-content--first">
            <p className="project-scope-main-content-text project-scope-fading">Select a layout to estimate square footage</p>
            <div className="project-scope-main-selection project-scope-fading">
              {
                ["straight","cornered","withwalls"].map((selection) => {
                  return (
                    <div className={"project-scope-main-selection-item "+((this.state.activeSelection === selection )
                      ? "project-scope-main-selection-item--selected":"")} key={selection} onClick={()=> {
                        this.handleSelectionChange(selection)
                    }}>
                      <div className={"project-scope-main-selection-item-img project-scope-main-selection-item-img--"+selection}/>
                    </div>
                  )
                })
              }
            </div>
            <div className="project-scope-sqft-mobile project-scope-fading">
              <div className="project-scope-sqft-button" onClick={this.showSquareFootCalc}>Help Me Calculate My Square Footage</div>
            </div>
          </div>
          <div className="project-scope-main-footer">
            <div className="project-scope-main-footer-cell project-scope-main-footer-cell--vis">
              <div className="footer-visualize" onClick={this.props.openKitchenVisualizerIframe}>
                <span className="footer-visualize-image"/>
                <span className="footer-visualize-text">Visualize My Kitchen</span>
              </div>
            </div>
            <div className="project-scope-main-footer-cell project-scope-main-footer-cell--buttons">
              <div className="project-scope-sqft project-scope-fading">
                <div className="project-scope-sqft-button" onClick={this.showSquareFootCalc}>Help Me Calculate My Square Footage</div>
              </div>
              <button className="project-scope-main-footer-button project-scope-main-footer-button--next"
                      onClick={() => { this.props.changeStep(+1) }}>{(this.state.material > 1) ? "Next":"Skip"}</button>
            </div>
          </div>
        </div>
      ) : (
        <div className="project-scope-box-content">
          <div className="project-scope-materials-wrapper">
            <div className="project-scope-maretials-container">
              <p>Estimated SQFT of Countertop</p>
              <QuantityTextField value={this.state.material} className="project-scope-textbox"
                                 onBlur={this.handleMaterialChange}
                                 title="Material quantity"/>
            </div>
          </div>
        </div>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/projectScope/materialContent.js